// extracted by mini-css-extract-plugin
module.exports = {"icono":"RequisitosListado__icono__1bvPS","titulo":"RequisitosListado__titulo__2PABY"};